module.exports = __webpack_public_path__ + "static/img/home-battery-02@tw.f9c7352.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/home-battery-02@tw.jpg
// module id = 4bLK
// module chunks = 0